import { useMemo } from "react";

import AppStoreButton, { StoreEnum } from "@/components/app-store-button";
import { Separator } from "@/components/ui/separator";

import type { MenuItemGroupType, MenuItemType } from "./menu-items";

interface MenuGroupProps {
  items: MenuItemType[];
  withDivider: boolean;
}

function MenuGroup({ items, withDivider }: MenuGroupProps) {
  const menuItems = useMemo(
    () =>
      items.reduce((accum, { content, hide, key }) => {
        if (!hide) {
          accum.push(<div key={key}>{content}</div>);
        }

        return accum;
      }, [] as React.ReactNode[]),
    [items]
  );

  if (!menuItems.length) {
    return null;
  }

  return (
    <>
      {withDivider && (
        <Separator className="bg-white/10" orientation="horizontal" />
      )}
      {menuItems}
    </>
  );
}

interface DesktopMenuProps {
  items: MenuItemGroupType[];
}

export default function DesktopMenu({ items }: DesktopMenuProps) {
  return (
    <nav className="flex max-h-[calc(100vh-80px)] flex-col items-stretch gap-2.5 overflow-y-auto rounded-[15px] bg-[url(/images/main-bg.jpg)] bg-top bg-no-repeat p-2.5 shadow-0-0-8 shadow-black/25">
      {items.map((group, index) =>
        !Array.isArray(group) && group.hide ? null : (
          <MenuGroup
            items={Array.isArray(group) ? group : group.items}
            // biome-ignore lint/suspicious/noArrayIndexKey: dynamic groups, fine
            key={index}
            withDivider={!!index}
          />
        )
      )}
      <div className="grid standalone:hidden grid-cols-2 gap-5 p-2.5">
        <AppStoreButton className="h-12 w-full rounded-lg" />
        <AppStoreButton
          className="h-12 w-full rounded-lg"
          store={StoreEnum.GOOGLE}
        />
      </div>
    </nav>
  );
}
